import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { fullName } from "../../utils/user";
import classes from './index.module.scss';
const TypingIndicator = ({ firstName, lastName, visible, className, viewingAs = 'client', }) => {
    const { t } = useTranslation();
    const firstOrFullName = fullName({ firstName, lastName });
    let text;
    if (firstName) {
        text = t('{{firstOrFullName}} is typing', { firstOrFullName });
    }
    else if (viewingAs === 'agent') {
        text = t('user is typing');
    }
    else if (viewingAs === 'client') {
        text = t('agent is typing');
    }
    return (_jsx("div", Object.assign({ className: classNames(classes.root, className) }, { children: visible && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: classes.typingIndicator }, { children: [_jsx("div", { className: classes.ellipse1 }, void 0), _jsx("div", { className: classes.ellipse2 }, void 0), _jsx("div", { className: classes.ellipse3 }, void 0)] }), void 0), _jsx(Typography, Object.assign({ color: "text-02", variant: "caption-small" }, { children: text }), void 0)] }, void 0)) }), void 0));
};
export default TypingIndicator;
//# sourceMappingURL=index.js.map